import React, { useContext, useEffect, useState } from "react";
import { Layout, Menu, Breadcrumb, Select, Form, Badge, Grid } from "antd";
import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
  FileSearchOutlined,
  AppstoreAddOutlined,
  LogoutOutlined,
  BellOutlined,
  AlertOutlined,
  MessageOutlined,
  UserSwitchOutlined,
  SearchOutlined,
  CameraOutlined,
  EnvironmentOutlined,
  FileDoneOutlined,
  ToolOutlined,
  FileTextOutlined,
  ApiOutlined,
  MergeOutlined,
  SolutionOutlined,
  SafetyCertificateOutlined,
  ApiFilled,
  DeploymentUnitOutlined,
  HistoryOutlined,
  BankOutlined,
} from "@ant-design/icons";
import {
  Link,
  Redirect,
  useNavigate,
  useLocation,
  useHistory,
} from "react-router-dom";
import AutoSessionOut from "../_services/AutoSessionOut";
import { userService } from "../_services/user.service";
import { userConstants } from "../_constants/user.constants";
import { LanguageContext } from "../context/LanguageContext";
import { professionalService } from "../_services";
import { notificationAction } from "../_actions/notifications.actions";
import { wantedNotificationAction } from "../_actions/wantedNotification.action";
import { userActions } from "../_actions";
const { Option } = Select;
const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

export const AppLayout = React.memo((props) => {
  let history = useHistory();
  let location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [notificationCount, setNotificationCount] = useState();
  const [wantedList, setWantedList] = useState([]);
  const [users, setUsers] = useState();
  const [context, setcontext] = useState(this);

  const [activeMenu, setActiveMenu] = useState();
  const [selectLanguage, setSelectLanguage] = useState();
  const onCollapse = () => {
    setCollapsed(!collapsed);
  };
  const { language, setLanguage, t } = useContext(LanguageContext);

  const handleChange = (e) => {
    setLanguage(e);
    languageSave(e);
  };
  let user = JSON.parse(localStorage.getItem("user"));
  const languageSearch = () => {
    professionalService.lanaguagesearch(user.id).then((res) => {
      if (res.data[0]) {
        console.log("res", res?.data[0]);
        setSelectLanguage(res?.data[0]);
        setLanguage(res?.data[0]?.language);
      } else {
        setLanguage("mr");
      }
    });
  };
  console.log("user", user);

  useEffect(() => {
    const intervalId = setInterval(() => {
      UserHeartbeat();
    }, 30000); // 30 seconds

    return () => {
      clearInterval(intervalId); // IMPORTANT
    };
  }, []);

  const UserHeartbeat = () => {
    const temp = {
      userId: user.id,
    };
    userActions
      .UserHeartbeat(temp)
      .then((res) => {
        console.log("Heartbeat OK");
      })
      .catch((err) => {
        console.error("Heartbeat failed", err);
      });
  };

  const countPreventiveNotification = () => {
    let temp = {};
    if (user.role === "4") {
      temp.city = user?.cityId;
    } else if (user.role === "2") {
      temp.district = [user?.districtId];
    } else {
      temp.district = user.map_districtId;
    }
    notificationAction.countPreventiveNotification(temp).then((res) => {
      res &&
        res.json().then((data) => {
          setNotificationCount(data.count);
        });
    });
  };
  const loadWantedNotifications = () => {
    if (!user || (user.role !== "2" && user.role !== "4")) {
      setWantedList([]);
      return;
    }
    wantedNotificationAction
      .getWantedNotificationList({
        role: user.role,
        cityId: user.cityId,
        districtId: user.districtId,
      })
      .then((res) => {
        setWantedList(res && res.data ? res.data : []);
      })
      .catch(() => {
        setWantedList([]);
      });
  };

  useEffect(() => {
    languageSearch();
    countPreventiveNotification();
    loadWantedNotifications();
  }, []);

  const languageSave = (e) => {
    const temp = {
      language: e,
      user_id: user.id,
      id: selectLanguage?.id,
    };
    professionalService.languageSave(temp).then((res) => {
      console.log("res", res);
      languageSearch();
      window.location.reload();
    });
  };

  const data = localStorage.getItem("allocatedVerification") || "";
  const GangDetection = localStorage.getItem("gangDetection") || "";
  const imageProvision = localStorage.getItem("image_provision") || false;
  const faceSearchAllocation =
    localStorage.getItem("faceSearchAllocation") || "";

  if (data !== undefined && data !== "") {
    try {
      var allocatedVerification = JSON.parse(data);

      if (allocatedVerification?.plan === "Plan C") {
        var appUsers = localStorage.getItem("appUsers");
      }
    } catch (error) {}
  } else {
  }
  if (GangDetection !== undefined && GangDetection !== "") {
    try {
      var allocateGangDetection = JSON.parse(GangDetection);

      if (allocateGangDetection?.plan === "Plan C") {
        var appUsers = localStorage.getItem("appUsers");
      }
    } catch (error) {}
  } else {
  }
  if (faceSearchAllocation !== undefined && faceSearchAllocation !== "") {
    try {
      var allocateFaceSearch = JSON.parse(faceSearchAllocation);
    } catch (error) {}
  } else {
  }
  useEffect(() => {
    if (location.pathname === "/AppUserLogin") {
      setTimeout(() => {
        setActiveMenu("2");
      }, 100);
    } else if (location.pathname === "/") {
      setTimeout(() => {
        setActiveMenu("1");
      }, 100);
    } else if (location.pathname === "/finds") {
      setTimeout(() => {
        setActiveMenu("3");
      }, 100);
    } else if (location.pathname === "/news") {
      setTimeout(() => {
        setActiveMenu("4");
      }, 100);
    } else if (location.pathname === "/notifications") {
      setTimeout(() => {
        setActiveMenu("5");
      }, 100);
    } else if (location.pathname === "/gps") {
      setTimeout(() => {
        setActiveMenu("6");
      }, 100);
    } else if (location.pathname === "/wanted") {
      setTimeout(() => {
        setActiveMenu("7");
      }, 100);
    } else if (location.pathname === "/help") {
      setTimeout(() => {
        setActiveMenu("9");
      }, 100);
    } else if (location.pathname === "/aboutus") {
      setTimeout(() => {
        setActiveMenu("8");
      }, 100);
    } else if (location.pathname === "/reports") {
      setTimeout(() => {
        setActiveMenu("11");
        setActiveMenu("11");
      }, 100);
    } else if (location.pathname === "/reports3") {
      setTimeout(() => {
        setActiveMenu("12");
        setActiveMenu("12");
      }, 100);
    } else if (location.pathname === "/reports4") {
      setTimeout(() => {
        setActiveMenu("13");
      }, 100);
    } else if (location.pathname === "/reports5") {
      setTimeout(() => {
        setActiveMenu("14");
        setActiveMenu("14");
      }, 100);
    } else if (location.pathname === "/CCTVLocation") {
      setTimeout(() => {
        setActiveMenu("15");
      }, 100);
    } else if (location.pathname === "/spotservellience") {
      setTimeout(() => {
        setActiveMenu("16");
      }, 100);
    } else if (location.pathname === "/reportPoliceSpotvise") {
      setTimeout(() => {
        setActiveMenu("17");
        setActiveMenu("17");
      }, 100);
    } else if (location.pathname === "/reportAdminSpotvise") {
      setTimeout(() => {
        setActiveMenu("17");
        setActiveMenu("17");
      }, 100);
    } else if (location.pathname === "/samans") {
      setTimeout(() => {
        setActiveMenu("5");
      }, 100);
    } else if (location.pathname === "/document-verification") {
      setTimeout(() => {
        setActiveMenu("19");
      }, 100);
    } else if (location.pathname === "/reportPlus2Report") {
      setTimeout(() => {
        setActiveMenu("20");
      }, 100);
    } else if (location.pathname === "/reportArrest") {
      setTimeout(() => {
        setActiveMenu("21");
      }, 100);
    } else if (location.pathname === "/reportPreventive") {
      setTimeout(() => {
        setActiveMenu("22");
      }, 100);
    } else if (location.pathname === "/login") {
      setTimeout(() => {
        setActiveMenu("23");
      }, 100);
    } else if (location.pathname === "/ProfessionalForm") {
      setTimeout(() => {
        setActiveMenu("24");
      }, 100);
    } else if (location.pathname === "/gps") {
      setTimeout(() => {
        setActiveMenu("26");
      }, 100);
    } else if (location.pathname === "/guna-report") {
      setTimeout(() => {
        setActiveMenu("30");
      }, 100);
    } else if (location.pathname === "/ncr") {
      setTimeout(() => {
        setActiveMenu("40");
      }, 100);
    } else if (location.pathname === "/notice-report") {
      setTimeout(() => {
        setActiveMenu("41");
      }, 100);
    } else if (location.pathname === "/act-section") {
      setTimeout(() => {
        setActiveMenu("act-section");
      }, 100);
    } else if (location.pathname === "/modas") {
      setTimeout(() => {
        setActiveMenu("modus");
      }, 100);
    } else if (location.pathname === "/sub-cities") {
      setTimeout(() => {
        setActiveMenu("sub-city");
      }, 100);
    } else if (location.pathname === "/api-details") {
      setTimeout(() => {
        setActiveMenu("api-details");
      }, 100);
    } else if (location.pathname === "/api-log") {
      setTimeout(() => {
        setActiveMenu("api-log");
      }, 100);
    } else if (location.pathname === "/postman-collection") {
      setTimeout(() => {
        setActiveMenu("postman-collection");
      }, 100);
    } else if (location.pathname === "/api-manager") {
      setTimeout(() => {
        setActiveMenu("api-manager");
      }, 100);
    } else if (location.pathname === "/guna-merge") {
      setTimeout(() => {
        setActiveMenu("guna-merge");
      }, 100);
    } else if (location.pathname === "/verification") {
      setTimeout(() => {
        setActiveMenu("verification");
      }, 100);
    } else if (location.pathname === "/gang-detection") {
      setTimeout(() => {
        setActiveMenu("gang-detection");
      }, 100);
    } else if (location.pathname === "/gang-detection") {
      setTimeout(() => {
        setActiveMenu("gang-detection");
      }, 100);
    } else if (location.pathname === "/logs") {
      setTimeout(() => {
        setActiveMenu("logs");
      }, 100);
    } else if (location.pathname === "daily-repots") {
      setTimeout(() => {
        setActiveMenu("daily");
      }, 100);
    } else if (location.pathname === "/states") {
      setTimeout(() => {
        setActiveMenu("states");
      }, 100);
    } else if (location.pathname == "/guna-hide") {
      setTimeout(() => {
        setActiveMenu("guna-hide");
      }, 100);
    } else if (location.pathname === "/fuzzy") {
      setTimeout(() => {
        setActiveMenu("fuzzy");
      }, 100);
    } else if (location.pathname === "/crime-null") {
      setTimeout(() => {
        setActiveMenu("crime-null");
      }, 100);
    } else if (location.pathname === "/douable-cr") {
      setTimeout(() => {
        setActiveMenu("douable-cr");
      }, 100);
    } else if (location.pathname === "/cctns-missing-report") {
      setTimeout(() => {
        setActiveMenu("cctns-missing-report");
      }, 100);
    } else if (location.pathname === "/image-map") {
      setTimeout(() => {
        setActiveMenu("image-map");
      }, 100);
    } else if (location.pathname === "/image-provision") {
      setTimeout(() => {
        setActiveMenu("image-provision");
      }, 100);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (user && user.role && user.role === "2") {
      return <Redirect to="/login" />;
    }
  }, [user]);

  const changeRoute = (activeKey) => {
    history.push("/AppUserLogin");
  };

  const fnSessionLogout = () => {
    sessionStorage.setItem("sessionOut", true);
    userService.logout();
    window.location.href = window.location.origin + "/#/login";
    return { type: userConstants.LOGOUT };
  };

  const autoLogout = () => {
    let obj = {
      userId: user.id,
    };
    userService.UserLogout(obj);
  };
  const logout = () => {
    userService.logout();
    autoLogout();
  };

  // const linkTarget = {
  //   pathname: "/AppUserLogin",
  //   key: Math.random(), // we could use Math.random, but that's not guaranteed unique.
  //   state: {
  //     applied: false
  //   }
  // };

  return (
    <Layout
      style={{ minHeight: "100vh" }}
      className={`${!collapsed ? "" : "collapsed"}`}
    >
      <AutoSessionOut
        timeOut="30"
        fnSessionLogout={fnSessionLogout}
      ></AutoSessionOut>
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
        <div className="logo">
          {collapsed ? (
            <span style={{ whiteSpace: "nowrap" }}>CMIS</span>
          ) : (
            <span
              style={{
                whiteSpace: "nowrap",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                color: "#c5c2c2",
              }}
            >
              <span>CMIS</span>
              <small style={{ fontSize: "8px" }}>
                Criminal Monitoring Intelligent System
              </small>
            </span>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[activeMenu]}
          defaultSelectedKeys={["1"]}
        >
          {/* <Menu.Item key="1" icon={<PieChartOutlined />}>
            Option 1
          </Menu.Item>
          <Menu.Item key="2" icon={<DesktopOutlined />}>
            Option 2
          </Menu.Item> */}
          {user && user.role && user.role === "4" ? (
            <>
              <Menu.Item key="1" icon={<AppstoreOutlined />}>
                <Link to="/">{t("dashboard")}</Link>
              </Menu.Item>
              <Menu.Item key="2" icon={<UserSwitchOutlined />}>
                <Link to="/AppUserLogin">{t("app_user")}</Link>
              </Menu.Item>
              <Menu.Item key="3" icon={<SearchOutlined />}>
                <Link to="/finds">{t("search_accused")}</Link>
              </Menu.Item>
              {imageProvision && (
                <Menu.Item key="image-map" icon={<CameraOutlined />}>
                  <Link to="/image-map">Image Map</Link>
                </Menu.Item>
              )}

              <Menu.Item
                key="6"
                style={{ marginBottom: "-2px" }}
                icon={<FileTextOutlined />}
              >
                <Link to="/cctns-missing-report" title={t("cctns_missing")}>
                  {t("cctns_missing")}
                </Link>
              </Menu.Item>

              {/* <Menu.Item key="6" icon={<FileSearchOutlined />}>
                <Link to="/gps">GPS Details</Link>
              </Menu.Item> */}
              {/* client told hide  */}
              {/* <Menu.Item key="15" icon={<CameraOutlined />}>
                <Link to="/CCTVLocation" title={t("cctv_network")}>
                  {t("cctv_network")}
                </Link>
              </Menu.Item> */}
              {/* <Menu.Item key="19" icon={<FileSearchOutlined />}>
                <Link to="/reportPlus2Report">2plus Report</Link>
              </Menu.Item> */}
              {/* client told hide  */}
              {/* <Menu.Item key="16" icon={<EnvironmentOutlined />}>
                <Link to="/spotservellience" title={t("site_inspection")}>
                  {t("site_inspection")}
                </Link>
              </Menu.Item> */}
              {/* <Menu.Item key="7" icon={<FileSearchOutlined />}>
                <Link to="/wanted">Wanted</Link>
              </Menu.Item> */}
              {/* need to hide on date mar 24'25 */}
              {/* <Menu.Item key="4" icon={<FileSearchOutlined />}>
                <Link to="/news">बातमी</Link>
              </Menu.Item> */}
              {/* nedd comment as per client required */}
              {/* <Menu.Item key="5" icon={<FileSearchOutlined />}>
                <Link to="/samans">Samans</Link>
              </Menu.Item> */}
              {(allocatedVerification &&
                (allocatedVerification?.plan == "Plan A" ||
                  allocatedVerification?.plan == "Plan B")) ||
              (allocatedVerification?.plan == "Plan C" &&
                (appUsers === "true" || appUsers === true)) ? (
                <Menu.Item key="19" icon={<FileSearchOutlined />}>
                  <Link
                    to="/document-verification"
                    title={t("document_verification")}
                  >
                    {t("document_verification")}
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )}

              {(allocateGangDetection &&
                (allocateGangDetection?.plan == "Plan A" ||
                  allocateGangDetection?.plan == "Plan B")) ||
              (allocateGangDetection?.plan == "Plan C" &&
                (appUsers === "true" || appUsers === true)) ? (
                <SubMenu key="60" icon={<FileDoneOutlined />} title={t("gang")}>
                  {/* hide on date may 8'26 due to gang api not wokr */}
                  {/* <Menu.Item key="32" icon={<TeamOutlined />}>
                    <Link to="/gang-details" title={t("gang_detection")}>
                      {t("gang_detection")}
                    </Link>
                  </Menu.Item> */}
                  <Menu.Item key="61" icon={<TeamOutlined />}>
                    <Link to="/gang-search" title="Gang Search">
                      {t("gang_find")}
                    </Link>
                  </Menu.Item>
                </SubMenu>
              ) : (
                ""
              )}
              {faceSearchAllocation !== undefined &&
              faceSearchAllocation !== "" ? (
                <Menu.Item key="62" icon={<FileSearchOutlined />}>
                  <Link to="/find-face-search">Face Search</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {/* <Menu.Item key="10"  icon={<FileSearchOutlined />}  > 
                   <Link to="/reports">Reports</Link>
             </Menu.Item> */}
              <SubMenu
                key="11"
                icon={<FileDoneOutlined />}
                title={t("reports")}
              >
                {/* <Menu.Item key="3">आरोपी शोधा</Menu.Item> */}

                {/* hide content */}
                {/* <Menu.Item key="12" style={{ marginBottom: "-2px" }}>
                  <Link to="/reports3">
                    पोलिस स्टेशन निहाय गस्त आकडेवारी अहवाल
                  </Link>
                </Menu.Item> */}
                {/* hide  */}
                <Menu.Item key="daily" style={{ marginBottom: "-2px" }}>
                  <Link to="/daily-repots" title="Daily Reports">
                    {t("daily_reports")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="20" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPlus2Report" title={t("2_plus_report")}>
                    {t("2_plus_report")}
                  </Link>
                </Menu.Item>

                <Menu.Item key="22" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPreventive" title={t("preventive_action")}>
                    {t("preventive_action")}
                  </Link>
                </Menu.Item>

                <Menu.Item key="30" style={{ marginBottom: "-2px" }}>
                  <Link to="/guna-report">{t("guna_register")}</Link>
                </Menu.Item>
                <Menu.Item key="21" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportArrest" title={t("arrest_register_report")}>
                    {t("arrest_register_report")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="40" style={{ marginBottom: "-2px" }}>
                  <Link to="/ncr">अदखलपात्र गुन्हा रजिस्टर</Link>
                </Menu.Item>
                <Menu.Item key="41" style={{ marginBottom: "-2px" }}>
                  <Link to="/notice-report">{t("notice_register")}</Link>
                </Menu.Item>
                <Menu.Item key="11" style={{ marginBottom: "-2px" }}>
                  <Link to="/reports" title={t("accused_statistical_report")}>
                    {t("accused_statistical_report")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="6" style={{ marginBottom: "-2px" }}>
                  <Link to="/gps" title={t("accused_patrol_report")}>
                    {t("accused_patrol_report")}
                  </Link>
                </Menu.Item>

                {/* hide */}
                <Menu.Item key="13" style={{ marginBottom: "-2px" }}>
                  <Link to="/reports4" title={t("accused_not_yet_checked")}>
                    {t("accused_not_yet_checked")}
                  </Link>
                </Menu.Item>

                {/* hide  */}
                <Menu.Item key="14" style={{ marginBottom: "-2px" }}>
                  <Link
                    to="/reports5"
                    title={t("police_station_wise_app_user_list")}
                  >
                    {t("police_station_wise_app_user_list")}
                  </Link>
                </Menu.Item>
                {/* <Menu.Item key="17" style={{ marginBottom: '-2px' }}>
                    <Link to="/reportPoliceSpotvise">पोलीस स्टेशन Spot Vise लिस्ट</Link>
                  </Menu.Item> */}
                {/* hide */}
                <Menu.Item key="17" style={{ marginBottom: "-2px" }}>
                  <Link
                    to="/reportAdminSpotvise"
                    title={t("management_location_wise_list")}
                  >
                    {t("management_location_wise_list")}
                  </Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="23" icon={<LogoutOutlined />}>
                <Link to="/login" onClick={logout}>
                  {t("logout")}
                </Link>
              </Menu.Item>
            </>
          ) : user && user.role && user.role === "8" ? (
            <>
              <Menu.Item key="1" icon={<AppstoreOutlined />}>
                <Link to="/">{t("dashboard")}</Link>
              </Menu.Item>
              <SubMenu
                key="tool-menu"
                icon={<ToolOutlined />}
                title="CMIS Tool"
              >
                <Menu.Item key="guna-hide" icon={<DeploymentUnitOutlined />}>
                  <Link to="/guna-hide">Guna Hide Request</Link>
                </Menu.Item>
                <Menu.Item key="act-section" icon={<FileTextOutlined />}>
                  <Link to="/act-section">Act/Section</Link>
                </Menu.Item>
                <Menu.Item key="/states" icon={<EnvironmentOutlined />}>
                  <Link to="/states">States</Link>
                </Menu.Item>
                <Menu.Item
                  key="/cctns-districts-map"
                  icon={<EnvironmentOutlined />}
                >
                  <Link to="/cctns-districts-map">CCTNS Districts</Link>
                </Menu.Item>
                <Menu.Item
                  key="/cctns-districts-map"
                  icon={<EnvironmentOutlined />}
                >
                  <Link to="/cctns-cities-map">CCTNS Cities</Link>
                </Menu.Item>
                <Menu.Item key="modus" icon={<SolutionOutlined />}>
                  <Link to="/modas">{t("modus_operandi")}</Link>
                </Menu.Item>

                <Menu.Item key="sub-city" icon={<EnvironmentOutlined />}>
                  <Link to="/sub-cities">Sub City</Link>
                </Menu.Item>
                <Menu.Item key="logs" icon={<HistoryOutlined />}>
                  <Link to="/logs">Logs</Link>
                </Menu.Item>
                <Menu.Item key="api-manager" icon={<ApiOutlined />}>
                  <Link to="/api-manager">Add Api</Link>
                </Menu.Item>
                <Menu.Item key="fuzzy" icon={<FileSearchOutlined />}>
                  <Link to="/fuzzy">Fuzzy</Link>
                </Menu.Item>
                <Menu.Item key="crime-null" icon={<FileSearchOutlined />}>
                  <Link to="/crime-null">Registered Cases – Crime Null</Link>
                </Menu.Item>
                <Menu.Item key="crime-null" icon={<FileSearchOutlined />}>
                  <Link to="/douable-cr">Douable Cr – Crime </Link>
                </Menu.Item>
                <Menu.Item key="api-details" icon={<ApiOutlined />}>
                  <Link to="/api-details">API Details</Link>
                </Menu.Item>
                <Menu.Item key="api-log" icon={<DeploymentUnitOutlined />}>
                  <Link to="/api-log">Cctv log</Link>
                </Menu.Item>

                <Menu.Item key="guna-merge" icon={<MergeOutlined />}>
                  <Link to="/allocation-guna-merge">Allocation Guna Merge</Link>
                </Menu.Item>
                <Menu.Item
                  key="face-search-allocation"
                  icon={<FileSearchOutlined />}
                >
                  <Link to="/face-search-allocation">
                    Face Search Allocation
                  </Link>
                </Menu.Item>

                <Menu.Item key="image-provision" icon={<CameraOutlined />}>
                  <Link to="/image-provision">Third Party Image Provision</Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="postman-collection" icon={<ApiOutlined />}>
                <Link to="/postman-collection">Postman-collection</Link>
              </Menu.Item>

              <SubMenu
                key="module-menu"
                icon={<AppstoreOutlined />}
                title="CMIS Module"
              >
                <Menu.Item
                  key="verification"
                  icon={<SafetyCertificateOutlined />}
                >
                  <Link to="/verification">Verification Module</Link>
                </Menu.Item>

                <Menu.Item key="gang-detection" icon={<TeamOutlined />}>
                  <Link to="/gang-detection">Gang Detection Tool</Link>
                </Menu.Item>
              </SubMenu>

              <Menu.Item key="5" icon={<FileSearchOutlined />}>
                <Link to="/notifications">Notifications</Link>
              </Menu.Item>
              <Menu.Item key="8" icon={<FileSearchOutlined />}>
                <Link to="/aboutus">About us</Link>
              </Menu.Item>

              <Menu.Item key="9" icon={<FileSearchOutlined />}>
                <Link to="/help">Help</Link>
              </Menu.Item>
              <Menu.Item
                key="43"
                icon={<MessageOutlined />}
                title={t("suggestion_feedback")}
              >
                <Link to="/suggestion-feedback">
                  {t("suggestion_feedback")}
                </Link>
              </Menu.Item>
              <Menu.Item key="23" icon={<LogoutOutlined />}>
                <Link to="/login" onClick={logout}>
                  {t("logout")}
                </Link>
              </Menu.Item>
            </>
          ) : (user && user.role && user.role === "9") ||
            (user && user.role === "10") ? (
            <>
              <Menu.Item key="1" icon={<AppstoreOutlined />}>
                <Link to="/">{t("dashboard")}</Link>
              </Menu.Item>
              {(user.role === "9" || user.role == "10") &&
              !Array.isArray(user.map_districtId) ? (
                ""
              ) : (
                <>
                  <Menu.Item key="3" icon={<SearchOutlined />}>
                    <Link to="/finds">{t("search_accused")}</Link>
                  </Menu.Item>
                  {imageProvision && (
                    <Menu.Item key="image-map" icon={<CameraOutlined />}>
                      <Link to="/image-map">Image Map</Link>
                    </Menu.Item>
                  )}
                  <Menu.Item
                    key="6"
                    style={{ marginBottom: "-2px" }}
                    icon={<FileTextOutlined />}
                  >
                    <Link to="/cctns-missing-report" title={t("cctns_missing")}>
                      {t("cctns_missing")}
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item key="16" icon={<EnvironmentOutlined />}>
                    <Link to="/spotservellience">स्थळ निरीक्षण</Link>
                  </Menu.Item> */}
                  <SubMenu
                    key="11"
                    icon={<FileDoneOutlined />}
                    title={t("reports")}
                  >
                    <Menu.Item key="daily" style={{ marginBottom: "-2px" }}>
                      <Link to="/daily-repots" title="Daily Reports">
                        {t("daily_reports")}
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="20" style={{ marginBottom: "-2px" }}>
                      <Link to="/reportPlus2Report" title={t("2_plus_report")}>
                        {t("2_plus_report")}
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="22"
                      style={{ marginBottom: "-2px" }}
                      disabled={
                        (user.role === "9" || user.role == "10") &&
                        !Array.isArray(user.map_districtId)
                      }
                    >
                      <Link
                        to="/reportPreventive"
                        title={t("preventive_action")}
                      >
                        {t("preventive_action")}
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key="30"
                      style={{ marginBottom: "-2px" }}
                      disabled={
                        (user.role === "9" || user.role == "10") &&
                        !Array.isArray(user.map_districtId)
                      }
                    >
                      <Link to="/guna-report">{t("guna_register")}</Link>
                    </Menu.Item>
                    <Menu.Item key="21" style={{ marginBottom: "-2px" }}>
                      <Link
                        to="/reportArrest"
                        title={t("arrest_register_report")}
                      >
                        {t("arrest_register_report")}
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="40" style={{ marginBottom: "-2px" }}>
                      <Link to="/ncr">अदखलपात्र गुन्हा रजिस्टर</Link>
                    </Menu.Item>
                    <Menu.Item key="41" style={{ marginBottom: "-2px" }}>
                      <Link to="/notice-report">{t("notice_register")}</Link>
                    </Menu.Item>
                    <Menu.Item key="11" style={{ marginBottom: "-2px" }}>
                      <Link
                        to="/reports"
                        title={t("accused_statistical_report")}
                      >
                        {t("accused_statistical_report")}
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="6" style={{ marginBottom: "-2px" }}>
                      <Link to="/gps" title={t("accused_patrol_report")}>
                        {t("accused_patrol_report")}
                      </Link>
                    </Menu.Item>

                    <Menu.Item key="14" style={{ marginBottom: "-2px" }}>
                      <Link
                        to="/reports5"
                        title={t("police_station_wise_app_user_list")}
                      >
                        {t("police_station_wise_app_user_list")}
                      </Link>
                    </Menu.Item>

                    <Menu.Item key="17" style={{ marginBottom: "-2px" }}>
                      <Link
                        to="/reportAdminSpotvise"
                        title={t("management_location_wise_list")}
                      >
                        {t("management_location_wise_list")}
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                </>
              )}
              <Menu.Item key="23" icon={<LogoutOutlined />}>
                <Link to="/login" onClick={logout}>
                  {t("logout")}
                </Link>
              </Menu.Item>
            </>
          ) : user && user.role === "12" ? (
            <>
              <Menu.Item key="1" icon={<AppstoreOutlined />}>
                <Link to="/">{t("dashboard")}</Link>
              </Menu.Item>
              <Menu.Item key="3" icon={<SearchOutlined />}>
                <Link to="/finds">{t("search_accused")}</Link>
              </Menu.Item>

              <SubMenu
                key="11"
                icon={<FileDoneOutlined />}
                title={t("reports")}
              >
                <Menu.Item key="20" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPlus2Report" title={t("2_plus_report")}>
                    {t("2_plus_report")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="22" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPreventive" title={t("preventive_action")}>
                    {t("preventive_action")}
                  </Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="23" icon={<LogoutOutlined />}>
                <Link to="/login" onClick={logout}>
                  {t("logout")}
                </Link>
              </Menu.Item>
            </>
          ) : (
            <>
              <Menu.Item key="1" icon={<AppstoreOutlined />}>
                <Link to="/">{t("dashboard")}</Link>
              </Menu.Item>
              {imageProvision && (
                <Menu.Item key="image-map" icon={<CameraOutlined />}>
                  <Link to="/image-map">Image Map</Link>
                </Menu.Item>
              )}
              <SubMenu
                key="sub1"
                icon={<UserOutlined />}
                title={t("professional_criminal")}
              >
                {/* <Menu.Item key="3">आरोपी शोधा</Menu.Item> */}
                <Menu.Item key="42">
                  <Link to="/add-crime">{t("add_new_accused")}</Link>
                </Menu.Item>
                <Menu.Item key="24">
                  <Link to="/ProfessionalForm">{t("aaropi_shodha")}</Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item
                key="6"
                style={{ marginBottom: "-2px" }}
                icon={<FileTextOutlined />}
              >
                <Link to="/cctns-missing-report" title={t("cctns_missing")}>
                  {t("cctns_missing")}
                </Link>
              </Menu.Item>
              {/* hide */}
              {/* <Menu.Item key="16" icon={<EnvironmentOutlined />}>
                <Link to="/spotservellience">स्थळ निरीक्षण</Link>
              </Menu.Item> */}

              {(allocatedVerification &&
                allocatedVerification?.plan == "Plan B") ||
              (allocatedVerification?.plan == "Plan C" &&
                (appUsers === "true" || appUsers === true)) ? (
                <Menu.Item key="19" icon={<FileSearchOutlined />}>
                  <Link
                    to="/document-verification"
                    title={t("document_verification")}
                  >
                    {t("document_verification")}
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {/* {(allocateGangDetection &&
                (allocateGangDetection?.plan == "Plan A" ||
                  allocateGangDetection?.plan == "Plan B")) ||
              (allocateGangDetection?.plan == "Plan C" &&
                (appUsers === "true" || appUsers === true)) ? (
                <Menu.Item key="32" icon={<FileSearchOutlined />}>
                  <Link to="gang-details" title={t("gang_detection")}>
                    {t("gang_detection")}
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )} */}
              {(allocateGangDetection &&
                (allocateGangDetection?.plan == "Plan A" ||
                  allocateGangDetection?.plan == "Plan B")) ||
              (allocateGangDetection?.plan == "Plan C" &&
                (appUsers === "true" || appUsers === true)) ? (
                <SubMenu key="60" icon={<FileDoneOutlined />} title={t("gang")}>
                  {/* hide on date may 8'26 due to gang api not wokr */}
                  {/* <Menu.Item key="32" icon={<TeamOutlined />}> */}

                  {/* <Link to="/gang-details" title={t("gang_detection")}>
                      {t("gang_detection")}
                    </Link> */}
                  {/* </Menu.Item> */}
                  <Menu.Item key="61" icon={<TeamOutlined />}>
                    <Link to="/gang-search" title="Gang Search">
                      {t("gang_find")}
                    </Link>
                  </Menu.Item>
                </SubMenu>
              ) : (
                ""
              )}
              {faceSearchAllocation !== undefined &&
              faceSearchAllocation !== "" ? (
                <Menu.Item key="62" icon={<FileSearchOutlined />}>
                  <Link to="/find-face-search">Face Search</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              <SubMenu
                key="11"
                icon={<FileDoneOutlined />}
                title={t("reports")}
              >
                <Menu.Item key="daily" style={{ marginBottom: "-2px" }}>
                  <Link to="/daily-repots" title="Daily Reports">
                    {t("daily_reports")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="20" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPlus2Report" title={t("2_plus_report")}>
                    {t("2_plus_report")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="22" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPreventive" title={t("preventive_action")}>
                    {t("preventive_action")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="30" style={{ marginBottom: "-2px" }}>
                  <Link to="/guna-report">{t("guna_register")}</Link>
                </Menu.Item>

                <Menu.Item key="21" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportArrest" title={t("arrest_register_report")}>
                    {t("arrest_register_report")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="40" style={{ marginBottom: "-2px" }}>
                  <Link to="/ncr">अदखलपात्र गुन्हा रजिस्टर</Link>
                </Menu.Item>
                <Menu.Item key="41" style={{ marginBottom: "-2px" }}>
                  <Link to="/notice-report">{t("notice_register")}</Link>
                </Menu.Item>
                {/* hide  */}
                <Menu.Item key="6">
                  <Link to="/gps" title={t("accused_patrol_report")}>
                    {t("accused_patrol_report")}
                  </Link>
                </Menu.Item>
                {/* hide */}
                <Menu.Item key="13" style={{ marginBottom: "-2px" }}>
                  <Link to="/reports4" title={t("accused_not_yet_checked")}>
                    {t("accused_not_yet_checked")}
                  </Link>
                </Menu.Item>
                <Menu.Item key="17" style={{ marginBottom: "-2px" }}>
                  <Link to="/reportPoliceSpotvise">
                    पोलीस स्टेशन Spot Vise लिस्ट
                  </Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="23" icon={<LogoutOutlined />}>
                <Link to="/login" onClick={logout}>
                  {t("logout")}
                </Link>
              </Menu.Item>
            </>
          )}

          {/* <SubMenu key="sub2" icon={<TeamOutlined />} title="Team">
            <Menu.Item key="6">Team 1</Menu.Item>
            <Menu.Item key="8">Team 2</Menu.Item>
          </SubMenu> */}
        </Menu>
      </Sider>
      <Layout
        className={`${!collapsed ? "site-layout" : "site-layout collapsed"}`}
      >
        {/* Header */}
        <Header
          style={{
            padding: "0 24px",
            position: "fixed",
            width: `calc(100% - ${collapsed ? 80 : 200}px)`,
            left: collapsed ? 80 : 200,
            zIndex: 1000,
            background: "#001529", // same as AntD dark header
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Menu
              theme="dark"
              mode="horizontal"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Select
                  defaultValue="mr"
                  style={{ width: 120 }}
                  value={language}
                  onChange={(e) => handleChange(e)}
                >
                  <Option value="en">English</Option>
                  <Option value="mr">मराठी</Option>
                </Select>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "16px", // spacing between bell and submenu
                  marginLeft: "auto",
                }}
              >
                {user && (user.role === "2" || user.role === "4") && (
                  <div style={{ cursor: "pointer", fontSize: "18px" }}>
                    <Badge
                      count={wantedList.length}
                      offset={[1, 2]}
                      style={{
                        backgroundColor: "#faad14",
                        fontSize: "14px",
                        height: "16px",
                        minWidth: "16px",
                        lineHeight: "16px",
                        padding: "0 4px",
                      }}
                    >
                      <Link
                        to="/wanted-notification"
                        title="wanted notification"
                        style={{ color: "white", fontSize: "20px" }}
                      >
                        <AlertOutlined />
                      </Link>
                    </Badge>
                  </div>
                )}
                <div
                  style={{ cursor: "pointer", fontSize: "18px" }}
                  onClick={() => console.log("Bell clicked")}
                >
                  <Badge
                    count={notificationCount}
                    offset={[1, 2]}
                    style={{
                      backgroundColor: "#ff4d4f",
                      fontSize: "14px",
                      height: "16px",
                      minWidth: "16px",
                      lineHeight: "16px",
                      padding: "0 4px",
                    }}
                  >
                    <Link
                      to="/preventive-notification"
                      title={t("preventive_notification")}
                      style={{ color: "white", fontSize: "20px" }}
                    >
                      <BellOutlined />
                    </Link>
                  </Badge>
                </div>
                <SubMenu
                  key="SubMenu"
                  icon={<SettingOutlined />}
                  title={user.userid}
                >
                  <Menu.Item key="setting:1">
                    <Link to="/profile">
                      {t("profile")} {users}
                    </Link>
                  </Menu.Item>
                  {user && (user.role === "9" || user.role === "10") && (
                    <>
                      <Menu.Item key="">
                        <Link to="/map-police-station">Map Police Station</Link>
                      </Menu.Item>
                    </>
                  )}
                  {user && user.role === "12" && (
                    <>
                      <Menu.Item key="">
                        <Link to="/map-cities">Map Police Station</Link>
                      </Menu.Item>
                    </>
                  )}
                  <Menu.Item key="setting:2">
                    {" "}
                    <Link to="/aboutCIMS">About Us</Link>
                  </Menu.Item>
                  <Menu.Item key="setting:4">
                    <Link to="/login_details">{t("login_details")}</Link>
                  </Menu.Item>
                  <Menu.Item key="setting:2">
                    <Link to="/faq">{t("help")} </Link>
                  </Menu.Item>
                  <Menu.Item key="setting:3">
                    <Link to="/login" onClick={logout}>
                      {t("logout")}
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </div>
            </Menu>
          </div>
        </Header>
        <Content
          style={{ margin: "0 16px", paddingTop: "60px" }}
          className={`${!collapsed ? "" : "collapsed"}`}
        >
          {/* <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>User</Breadcrumb.Item>
                <Breadcrumb.Item>Bill</Breadcrumb.Item>
              </Breadcrumb> */}
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 360 }}
          >
            {props.component}
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          {/* Copyright ©2021 Developed By I MARK TECHNOLOGY */}
          <p>2021-2026 Developed and Managed by I Mark Technology</p>
        </Footer>
      </Layout>
    </Layout>
  );
});
